module.exports = __webpack_public_path__ + "static/media/destaque-linhas-biodina.1e34beba.jpg";